import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_ADMIN } from '~/contexts/admin-tenant/router/routes'

import { FacetName } from '~/features-swym/control-center/interfaces/admin-tenant'

const ADMIN_TENANT_ROUTE: RouteRecordRaw = {
  name: ROUTE_ADMIN.ADMIN_TENANT,
  path: '',
  redirect() {
    return { name: ROUTE_ADMIN.ADMIN_TENANT_FACET, params: { facet_name: FacetName.COMMUNITIES } }
  },
  meta: {
    leftPanel: false,
    name: 'admin-tenant',
  },
}

const ADMIN_TENANT_FACET_ROUTE: RouteRecordRaw = {
  name: ROUTE_ADMIN.ADMIN_TENANT_FACET,
  path: ':facet_name',
  component: () => import('~/contexts/admin-tenant/pages/[facet_name].vue'),
  meta: {
    leftPanel: false,
    name: 'admin-tenant',
  },
}

/** Register all community routes as child of "/community" namespace */
export function getRoutes() {
  return [
    ADMIN_TENANT_ROUTE,
    ADMIN_TENANT_FACET_ROUTE,
  ]
}
